import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { http } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = logged in
  const [credits, setCredits] = useState(null);

  const refreshCredits = useCallback(async () => {
    try {
      const { data } = await http.get("/account/credits");
      setCredits(data);
      return data;
    } catch {
      setCredits(null);
      return null;
    }
  }, []);

  const loadUser = useCallback(async () => {
    try {
      const { data } = await http.get("/auth/me");
      setUser(data);
      await refreshCredits();
    } catch {
      setUser(false);
      setCredits(null);
    }
  }, [refreshCredits]);

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  const login = async (email, password) => {
    const { data } = await http.post("/auth/login", { email, password });
    setUser(data);
    await refreshCredits();
    return data;
  };

  const register = async (payload) => {
    const { data } = await http.post("/auth/register", payload);
    setUser(data);
    await refreshCredits();
    return data;
  };

  const logout = async () => {
    try {
      await http.post("/auth/logout");
    } catch {}
    setUser(false);
    setCredits(null);
  };

  return (
    <AuthContext.Provider
      value={{ user, credits, setUser, login, register, logout, refreshCredits, setCredits }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
